module.exports = __webpack_public_path__ + "static/media/whatsapp-btn.d8b2c02c.webp";